import script from "./TopTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTab.vue?vue&type=script&setup=true&lang=js"

import "./TopTab.vue?vue&type=style&index=0&id=b0ab1c22&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0ab1c22"]])

export default __exports__